export const loading = {
    data() {
        return {
            isLoading: false
        }
    },

    mounted() {
        if (this.eventBus) {
            // Kept as a reference so beforeDestroy can actually detach it; an inline
            // arrow here cannot be passed to $off and leaks on every remount.
            this._onBusLoading = (val) => this.isLoading = val;
            this.eventBus.$on('loading', this._onBusLoading);
        }
    },

    beforeDestroy() {
        if (this.eventBus && this._onBusLoading) {
            this.eventBus.$off('loading', this._onBusLoading);
        }
    },

    methods: {
        loading(val) {
            if (typeof val === 'undefined') return this.isLoading;

            this.isLoading = val;

            this.$emit('loading', this.isLoading);
            if (this.eventBus) {
                this.eventBus.$emit('loading', this.isLoading);
            }
        },
    },
};